import axios from 'axios';
import { apiUrl } from './apiUrl';

export const create = order =>
    axios.post(`${apiUrl}/order`, order)

export const validate = (orderId, signature, authorizationNumber) =>
    axios.post(`${apiUrl}/validateOrder`, { orderId, signature, authorizationNumber })



// WEBPACK FOOTER //
// ./src/services/smartparking-api/Orders.js